import Action from '../Action'
// import './styles/ImportInfo.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import SelectorIcons from '../SelectorIcons';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import { importFunction } from '../../utils/utils';
import Search from "../generales/Search";
import Paginador from "../generales/Paginador";
import InputForm from '../generales/InputForm';
import Modal from "react-modal";
import ModalAddHost from './ModalAddHost';
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'80%',
    height:'70%',
    padding:'20px'
  },
};
const ImportInterna =({handleShowPopup,users_catalog,buscar_cis,server,languaje,mode,importLoading,closeImportModal,setImportLoading})=>{
 const [cisData,setCisData]=useState({
        request_user:"",
        auth_user:"",
        user_comment:"",
    })
      const [disabled,setDisabled]=useState(true)
    const [msgError,setMsgError]=useState(true)
    const [boolError,setBoolError]=useState(false)
    const [response,setResponse]=useState([])
    
const handleChange=(e)=>{
    const {name,value}=e.target

    setCisData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
}
       const changeOption=(option,index)=>{
      
         setCisData((prevState)=>{
                return {
                    ...prevState,
                    [option.filter]:option.label
                }
                
            })
            
    }

        const handleImport = async () => {
            setResponse([])
        
      
         
          setImportLoading(true);
      const data = {
  hostids: poolRows,
  request_user:cisData.request_user,
  auth_user: cisData.auth_user,
  user_comment: cisData.user_comment,
}
          try {
              const response = await fetch(server.url + '/api/v1/cassia/cis_v2/internal_import', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
                body: JSON.stringify(data), // Enviamos el FormData con el archivo
              });
              // const data1 = await response.json();
              // console.log(data1)
              if (response.ok) {
                  const data1 = await response.json();
                  setResponse(data1.data)
                  const keys = Object.keys(data1.data[0]);
                  const r_ok=data1.data.filter(item => item.hostid_creado	 !== "").length
                  const r_error=data1.data.filter(item => item.hostid_creado	 === "").length
                  // console.log(r_ok,r_error)
                  const values = data1.data.map(obj => Object.values(obj));

                  // Unir las claves con los valores
                  const result = [keys, ...values];
                  if(r_ok==0){
                    handleShowPopup('Error!!!',capitalizeFirstLetter((lang[languaje]['importError'])),capitalizeFirstLetter((lang[languaje]['msgImporAll'])), false)
                  }else{
                    handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['importCorr'])),(r_error!=0)?capitalizeFirstLetter((lang[languaje]['msgImpor'])):'', true)
                  }


                  setDisabled(true)
                  setImportLoading(false);
                  setBoolError(false);
                  buscar_cis()

                  closeImportModal()
              } else {
                  const data1 = await response.json();
                  setImportLoading(false);
                  setBoolError(true);
                  handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),data1.detail, false)
                  setMsgError(data1.detail);
                  throw new Error('Error en la importación');
              }
          } catch (error) {
              setImportLoading(false);
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),'Se produjo un error interno', false)
              // setBoolError(true);
              // setMsgError('Error al importar archivo');
              // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
              console.error('Error al importar archivo:', error);
          }
        };
 const [poolRows,setPoolRows]=useState([])
          const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }
  
    function closeAddHostModal() {
      
        setAddHostModalOpen(false);
    }

    useEffect(()=>{ 
        if(cisData.request_user==cisData.auth_user || cisData.request_user=="" || cisData.auth_user=="" || poolRows.length==0 || cisData.user_comment==""  ){
            setDisabled(true)
        }else{
            setDisabled(false)
        }
    },[cisData,poolRows])
    const {
  request_user,user_comment,
  auth_user}=cisData;
    return (
        <>
        <div className="cont-import-GS-box"> 
                        <div className='row-cont-input-file'>
                            <div style={{width:'80%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                               <div className="cont-msg-alert-confirm-action" style={{height:'100%'}}>
                            <div className="compact-msg-alert-confirm-action">
                                <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">
                                {'Para la importación masiva interna, es necesario seleccionar uno o más dispositivos previamente registrados. Esta acción creará un registro de configuración para cada dispositivo seleccionado, y las modificaciones que se realicen se reflejarán directamente en la tabla de dispositivos.'}

                                   
                                </div>
                            </div>
                            
                        </div>
                                {/* {'Para la importación masiva interna es necesario seleccionar 1 o mas dispositivos previamente registrados. Esta acción le creara un registro de configuración para cada dispositivo seleccionado y las modificaciones que se les realizen se veran afectadas directamente en la tabla de dispositivos'} */}
                            </div>
                            <div style={{width:'20%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                               <Action disabled={false} origen='Azul' titulo={'Seleccionar Dispositivos'}  action={openAddHostModal}/>
                            </div>
                        </div>
                        <div className='row-cont-input-file'>
                            <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-med)'}}>
                               {/* <div className="cont-msg-alert-confirm-action" style={{height:'100%'}}>
                            <div className="compact-msg-alert-confirm-action">
                                <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">
                                {'Para la importación masiva interna es necesario seleccionar 1 o mas dispositivos previamente registrados. Esta acción le creara un registro de configuración para cada dispositivo seleccionado y las modificaciones que se les realizen se veran afectadas directamente en la tabla de dispositivos'}

                                   
                                </div>
                            </div>
                             
                        </div>*/}
                                {"("+poolRows.length+")  Dispositivos seleccionados para importar"}
                            </div>
                            
                        </div>
                        <div className='row-cont-input-file' style={{height:'40%'}}> 
                          <div className={"compact-body-step-modal "}>
                                            <div className="row-form-modal">
                    {/* <div className="colum-form-modal">
                        {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                        <InputForm optionDefault={0} type='selector' endpoint='Users'msgError={'El Solicitante y Autorizador no pueden ser iguales'}  error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'request_user'} titulo={'Solicitante'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.request_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                        }
                        </div>
                  <div className="colum-form-modal">
                        {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                        <InputForm optionDefault={0} type='selector' endpoint='Users' msgError={'El Solicitante y Autorizador no pueden ser iguales'} error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'auth_user'} titulo={'Autorizador'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.auth_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                        }
                    </div> */}
                    <div className="colum-form-modal">
                                            {/* {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                                            <InputForm optionDefault={0} type='selector' endpoint='Users'msgError={'El Solicitante y Autorizador no pueden ser iguales'}  error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'request_user'} titulo={'Solicitante'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.request_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                                            } */}
                                          <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'request_user'} titulo={'Solicitante'} text={cisData.request_user} placeHolder={''} disabled={false} isRequired={true}/>
                                            
                                            </div>
                                      <div className="colum-form-modal">
                                            {/* {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                                            <InputForm optionDefault={0} type='selector' endpoint='Users' msgError={'El Solicitante y Autorizador no pueden ser iguales'} error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'auth_user'} titulo={'Autorizador'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.auth_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                                            } */}
                                             <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'auth_user'} titulo={'Autorizador'} text={cisData.auth_user} placeHolder={''} disabled={false} isRequired={true}/>
                    
                                        </div>
                  </div>
                                            
                                            <div className="row-form-modal">
                                              <div className="colum-form-modal">
                                                  {/* {(dataClasifications.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                                                  <InputForm optionDefault={0} type='selector' endpoint='field_option'msgError={''}  error={false} changeOption={changeOption}  attr={'classification_id'} titulo={'Clasificacion'} loading={dataClasifications.loading} data={dataClasifications.data.data} text={''} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={cisData.classification_id==null}/>
                                                  } */}
                                                  </div>
                                            
                                            </div>
                                             <div className="row-form-modal-dobel">
                                                  <InputForm type='textArea'  error={false} handleInputChange={handleChange}  attr={'user_comment'} titulo={'Comentarios'} text={cisData.user_comment} placeHolder={'Agregar comentarios'} disabled={false} isRequired={cisData.user_comment.length<5} coment={'(minimo 5 caracteres)'}/>
                          
                                            </div>
                                           
                                          </div>
                        
                        </div>
                       
                        <div className='row-cont-input-buttons'>
                        {(importLoading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                        (
                        <>
                        <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeImportModal}/>
                        <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['importar'])}  action={handleImport}/>
                        </>
                        )
                        }
                        </div>           
                    </div>
                    <Modal
        isOpen={addHostModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeAddHostModal}
        style={addHostModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalAddHost poolRows={poolRows} server={server} handleShowPopup={handleShowPopup}   setPoolRows={setPoolRows} languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalAddHost>
    </Modal>
        </>
    )

}

export default ImportInterna